module.exports = __webpack_public_path__ + "img/场租水单示例.08bff86b.png";